// extracted by mini-css-extract-plugin
module.exports = {"headersWrapper":"Header_headersWrapper__UjRbb","headerButton":"Header_headerButton__Ql53F","selected":"Header_selected__Zq5YM","tabIndicator":"Header_tabIndicator__3uhqT"};